import { CheckboxFieldModel } from '@types'

import { CheckboxGroup } from '@components/CheckboxGroup'

type SubmitterFieldCheckboxProps = {
  field: CheckboxFieldModel
  disabled?: boolean
  onChange: (updates: Partial<CheckboxFieldModel>) => void
}

export const SubmitterFieldCheckbox: React.FC<SubmitterFieldCheckboxProps> = ({
  field,
  disabled = false,
  onChange,
}: SubmitterFieldCheckboxProps) => {
  const options = field.options.map((option) => ({
    value: option.id,
    label: option.label,
    id: option.id,
  }))

  return (
    <CheckboxGroup
      options={options}
      required={field.required}
      label={field.label}
      defaultValues={field.values}
      disabled={disabled}
      onChange={(values) => onChange({ values })}
    />
  )
}
